import { render, staticRenderFns } from "./ClientInvoiceListItem.vue?vue&type=template&id=a770713e&scoped=true&"
import script from "./ClientInvoiceListItem.vue?vue&type=script&lang=js&"
export * from "./ClientInvoiceListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a770713e",
  null
  
)

export default component.exports